// extracted by mini-css-extract-plugin
export default {"item":"CheckListItem_item__0XZnt","checkIcon":"CheckListItem_checkIcon__wl4zv","text":"CheckListItem_text__NHZZ2","checkedText":"CheckListItem_checkedText__H6ZhQ"};